import DealsTable from "@/components/deals/DealsTable";

export default function DealsPage() {
  return (
    <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8 space-y-8">
      <DealsTable />
    </div>
  );
}
